module.exports = __webpack_public_path__ + "a62aff23343b968ddeb391448f61144f.pdf";